import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
/**
 * A button of ours opening the file picker, in place of a bare
 * <input type="file">, whose own button and text ("Choose File", "No file
 * chosen", its tooltip too) speak the browser's language, not the page's.
 * The file input still does the picking, hidden.
 *
 * Same as champis-events' poster button (EventAssignModal.tsx).
 */
export default class FileButton extends Component {
  input = null;
  view(vnode) {
    const {
      accept,
      onfile,
      icon,
      disabled,
      className = 'Button ChampisFileButton',
      title
    } = this.attrs;
    return [m(Button, {
      className: className,
      icon: icon,
      disabled: disabled,
      title: title,
      "aria-label": title,
      onclick: () => this.input?.click()
    }, vnode.children), m("input", {
      type: "file",
      accept: accept,
      hidden: true,
      oncreate: input => {
        this.input = input.dom;
      },
      onchange: e => {
        const input = e.target;
        const file = input.files?.[0];

        // The same file picked again (after "Retirer") still counts.
        input.value = '';
        if (file) onfile(file);
      }
    })];
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/FileButton', FileButton);